import React from "react"
import { processType } from "../helper"
import "../styles/style.scss"

const ShoppingCartStep = props => {
  const { processed } = props

  const processedStep = currentProccess => {
    let result = ""
    switch (currentProccess) {
      case processType.STEP1:
        if (processed === processType.STEP1) {
          result = "active"
        }
        if (
          processed === processType.STEP2 ||
          processed === processType.STEP3
        ) {
          result = "active completed"
        }
        break

      case processType.STEP2:
        if (processed === processType.STEP2) {
          result = "active"
        }
        if (processed === processType.STEP3) {
          result = "active completed"
        }
        break
      case processType.STEP3:
        if (processed === processType.STEP3) {
          result = "active completed"
        }
        break

      default:
        break
    }
    return result
  }

  return (
    <>
      <div>
        <ul className="steps mb-5">
          <li className={`step ${processedStep(processType.STEP1)}`}>
            <div className="step-info">
              <span className="step-name">商品編輯</span>
            </div>
          </li>

          <li className={`step ${processedStep(processType.STEP2)}`}>
            <div className="step-info">
              <span className="step-name">品項確認</span>
            </div>
          </li>
          <li className={`step ${processedStep(processType.STEP3)}`}>
            <div className="step-info completed">
              <span className="step-name">提交訂單</span>
            </div>
          </li>
        </ul>
      </div>
    </>
  )
}

export default ShoppingCartStep
